module.exports = __webpack_public_path__ + "03_very_short_brown.6d30c2ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_very_short_brown.png
// module id = GaHT
// module chunks = 0